import moment from 'moment';
import { events } from '@/services/wss/SystemEvents';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import powerUsageCache from './PowerUsageCache';
import powerUsageFetcher from './PowerUsageFetcher';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';
import { PU_HISTORY_DAYS } from './powerUsageConst';
import df from '@/services/utils/DateFormat';

const _name = 'PowerUsageEngine';

class PowerUsageEngine extends WssEventHandlerBase {
    _name = _name;

    bootup() {
        super.bootup();
        this.clear();

        this._unsub = this._wsNotifier.subscribe(events.OnPowerSummaryUpdated, this.onMessage);
    }

    clear() {
        super.clear();

        if (this._unsub) this._unsub();
    }

    /**
     * Upserts pushed summaries by rk. Accepts a single summary or {items: [...]}.
     * @param {object} data
     */
    onMessage = (data) => {
        try {
            // const items = Array.isArray(data) ? data : [data];
            powerUsageCache.addOrUpdate(data);
            this._notify(data);
        } catch (error) {
            this.logError('onMessage', error.message);
        }
    };

    /**
     * @returns {Promise<object|null>}
     */
    getLatest = async () => {
        try {
            const cached = powerUsageCache.getLatest();
            if (cached) return cached;

            await this.fetch();
            return powerUsageCache.getLatest();
        } catch (error) {
            this.logError('getLatest', error.message);
            return null;
        }
    };

    /**
     * Loads the last PU_HISTORY_DAYS days up to end of today.
     * @returns {Promise<object[]>}
     */
    fetch = () => {
        const end = moment().endOf('day').valueOf();
        const start = moment()
            .startOf('day')
            .subtract(PU_HISTORY_DAYS - 1, 'days')
            .valueOf();
        return this.refresh(start, end);
    };

    /**
     * Reloads summaries for the given range and replaces the cache.
     * @param {number} start - epoch ms
     * @param {number} end - epoch ms
     * @returns {Promise<object[]>}
     */
    refresh = async (start, end) => {
        try {
            end = df.addDay(end, 1);

            const items = await powerUsageFetcher.fetch(start, end);
            powerUsageCache.replaceAll(items);
            this._notify(items);
            return items;
        } catch (error) {
            this.logError('refresh', error.message);
            return [];
        }
    };

    // Carries only rks — consumers always re-read from powerUsageCache.
    _notify = (items) => {
        ComponentNotifier.notify(_name, 'dataChanged', { rks: items.map((s) => s.rk) });
    };
}

const powerUsageEngine = new PowerUsageEngine();
export default powerUsageEngine;
